import { Group, Stack, Text } from "@mantine/core";
import { IconFile, IconPlus } from "@tabler/icons-react";
import { IconButton } from "../../../mantine/components/IconButton/IconButton";

enum TemplateModalState {
  None,
  NewContract,
  NewTemplateContract
}

interface TemplateDecisionCardsProps {
  setModalState: React.Dispatch<React.SetStateAction<TemplateModalState>>;
}

function TemplateDecisionCards({ setModalState }: TemplateDecisionCardsProps) {
  return (
    <Stack gap="xl" justify="center">
      <div>
        <Text fw={500} size="md">
          Bitte wählen Sie, ob Sie Ihren Vertrag ohne oder mit einem
          Referenzvertrag erstellen möchten.
        </Text>
        <Text>
          Wenn Sie einen Referenzvertrag nutzen, werden bestehende Inhalte
          übernommen. Stellen Sie sicher, diese Inhalte zu überprüfen und bei
          Bedarf anzupassen.
        </Text>
      </div>
      <Group gap="md" justify="center">
        <IconButton
          color="primary"
          icon={IconPlus}
          size="lg"
          variant="outline"
          onClick={() => setModalState(TemplateModalState.NewContract)}
        >
          Ohne Referenzvertrag
        </IconButton>
        <IconButton
          color="primary"
          icon={IconFile}
          size="lg"
          variant="outline"
          onClick={() => setModalState(TemplateModalState.NewTemplateContract)}
        >
          Mit Referenzvertrag
        </IconButton>
      </Group>
    </Stack>
  );
}
export { TemplateDecisionCards, TemplateModalState };
